import styled from 'styled-components'

export const Container = styled.div`
  background: #f6f8fb;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
`

export const Content = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 25px;
  width: 100%;
  padding: 15px;
  max-width: 1250px;


  @media (max-width: 768px) {
    min-width: 100%;
  }
`
